import "./voucherdialogs.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../../Actions/Dialogs/DialogActions";
import { finishSale } from "../../../../Actions/SellScreen/SellScreenActions";
import { addPaymentToSale } from "../../../../Actions/SellScreen/SellScreenPaymentActions";
import Button from "../../../../Common/Buttons/Button";
import NoTranslate from "../../../../Common/NoTranslate";
import { type LocalDatabasePaymentMethod } from "../../../../Data/_Bases/BasePaymentMethodRepository";
import { type InjectedDataSourceProps, withDataSource } from "../../../../Data/DataStores/WithDataSource";
import { type SaleVoucherProduct } from "../../../../Reducers/SellScreen/SellScreenSaleReducerTypes";
import { type RootState } from "../../../../Reducers/ShopfrontReducers";
import { currency } from "../../../../Utilities/Generic/Numbers";
import FontAwesomeLight from "../../../../Utilities/Platform/FontAwesome/FontAwesomeLight";

function mapStateToProps(state: RootState): {
    register: null | string;
} {
    return {
        register: state.location.register ? state.location.register.id : null,
    };
}

const connector = connect(mapStateToProps);

interface Props extends ConnectedProps<typeof connector>, InjectedDataSourceProps {
    dispatch: ThunkDispatch<any, any, any>;
    amount: number;
    removeVouchers: Array<number>;
    vouchers: Array<SaleVoucherProduct>;
    register: string;
}

interface State {
    loading: boolean;
    methods: Array<LocalDatabasePaymentMethod>;
}

export class RefundFailedVouchersDialog extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            loading: true,
            methods: [],
        };

        this.handleMethodClick = this.handleMethodClick.bind(this);
        this.loadMethods = this.loadMethods.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    public componentDidMount(): void {
        this.loadMethods();
    }

    protected loadMethods(): Promise<void> {
        this.setState({
            loading: true,
        });

        return this.props.data
            .then(async source => {
                const register = await source.registers.get(this.props.register);

                return source.paymentMethods.all()
                    .then(methods => methods.filter(method => register.payment_methods.includes(method.uuid)))
                    .then(methods => {
                        methods.sort((a, b) => {
                            return a.name.localeCompare(b.name);
                        });

                        this.setState({
                            methods: methods,
                            loading: false,
                        });
                    });
            });
    }

    protected handleMethodClick(method: LocalDatabasePaymentMethod): void {
        this.props.dispatch(hideDialog());

        this.props.dispatch(addPaymentToSale(method.uuid, -this.props.amount, {
            cashout     : false,
            exact       : false,
            vouchers    : true,
            refund      : true,
            remove      : this.props.removeVouchers,
            removeAmount: this.props.amount,
        }));
    }

    protected handleCancel(e: React.MouseEvent<HTMLButtonElement>): void {
        e.stopPropagation();

        this.props.dispatch(finishSale("COMPLETED", {
            vouchers     : this.props.vouchers,
            voucherFailed: false,
            voucherCancel: false,
        }));
    }

    public render(): React.ReactNode {
        if(this.state.loading) {
            return (
                <FontAwesomeLight icon="spinner-third" spin />
            );
        }

        return (
            <div className="voucher-activate-method">
                <div className="voucher-instructions">
                    Select a payment method to refund the{" "}
                    <NoTranslate>
                        {currency(this.props.amount)}
                    </NoTranslate> due to an unsuccessful activation of the {this.props.vouchers[0].name}
                </div>
                <div className="voucher-methods">
                    {this.state.methods.map((method) => {
                        return (
                            <Button
                                key={method.uuid}
                                onClick={(): void => {
                                    this.handleMethodClick(method);
                                }}
                                style={{
                                    background : method.background_colour,
                                    color      : method.text_colour,
                                    borderColor: "#000000",
                                }}
                            >
                                {method.name}
                            </Button>
                        );
                    })}
                    <Button
                        type="button"
                        onClick={this.handleCancel}
                        classes={[ "voucher-button-cancel" ]}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        );
    }
}

export default connector(withDataSource(RefundFailedVouchersDialog));
